module.exports = __webpack_public_path__ + "img/ai_gept.86a0e7cf.png";